// 공용 **On/Off 슬라이드 스위치**(2026-09-27 첫 화면 개편 — "모든 On/Off 기능은 똑같이 슬라이드 적용").
// 체크박스 대신 쓴다. 접근성: role="switch" + aria-checked, 스페이스·엔터로 전환(button 기본 동작).

export function Switch({
  checked,
  onChange,
  disabled,
  label,
}: {
  checked: boolean;
  /** 눌렀을 때 — 바뀔 **목표값**을 준다(화면은 적용 결과로만 다시 그린다: 낙관적 갱신 여부는 부르는 쪽이 정한다). */
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** 스위치 옆 글(스위치와 함께 눌린다). */
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`switch-row${checked ? ' on' : ''}`}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="switch-label">{label}</span>
      <span className="switch-track" aria-hidden="true">
        <span className="switch-thumb" />
      </span>
    </button>
  );
}
